console.log("Custom JS Loaded");


// window.addEventListener("scroll", function () {

//   let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
//   let windowHeight = window.innerHeight;
//   let fullHeight = document.documentElement.scrollHeight;

//   let scrolled = (scrollTop + windowHeight) / fullHeight * 100;
//   let box = document.querySelector(".site-header");
//   // let box1 = document.querySelector(".black-color");
//   console.log("Scroll %:", scrolled.toFixed(2));

//   if (scrolled >= 40) {
//     console.log("Reached 80%");
//     box.classList.add("black-color")
//     console.log(box)
//   }

// });


window.addEventListener("scroll", function () {

  let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  let windowHeight = window.innerHeight;
  let fullHeight = document.documentElement.scrollHeight;

  let scrolled = (scrollTop + windowHeight) / fullHeight * 100;

  let header = document.querySelector(".site-header"); // change if different

  if (scrolled >= 40 && header) {
    header.classList.add("black-color");
    console.log(header)
  } else if (header) {
    header.classList.remove("black-color");
  }

});